import React from 'react';

import { Icon } from 'b3';
import FergusLogo from '../../FergusLogo';
import TimelineItem from './TimelineItem';


export default function UservoiceNoteTimelineItem(props) {
	var icon 	= <Icon icon="volume-loud-1" />;
	var avatar = <FergusLogo className="avatar" />;
    var typeLabel = <span>Uservoice<br/>Note</span>;
    var isLongContent = props.note.length > 230;

    return (
        <TimelineItem
        	type="uservoicenote"
        	typeLabel={typeLabel}
        	avatar={avatar}
        	icon={icon}
            isLongContent={isLongContent}
        >
        	<span dangerouslySetInnerHTML={{__html: props.note}}></span>
        </TimelineItem>
    );
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/UservoiceNoteTimelineItem.js